"use client";

import React, { useState, useRef, useEffect, useCallback } from "react";

function FraudBanner() {
    const [dismissed, setDismissed] = useState(false);
    const bannerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function updateHeight() {
            if (bannerRef.current) {
                const height = bannerRef.current.offsetHeight;
                document.documentElement.style.setProperty("--banner-height", `${height}px`);
            }
        }

        if (!dismissed) {
            updateHeight();
            window.addEventListener("resize", updateHeight);
            return () => window.removeEventListener("resize", updateHeight);
        }
    }, [dismissed]);

    const handleDismiss = useCallback(() => {
        document.documentElement.style.setProperty("--banner-height", "0px");
        setDismissed(true);
    }, []);

    if (dismissed) return null;

    return (
        <>
            <div
                ref={bannerRef}
                role="alert"
                className="fixed top-0 left-0 right-0 z-[51] bg-darkBlue text-white lg:pl-[11.75rem]"
            >
                <div className="max-w-[1380px] mx-auto px-4 py-3 md:px-8">
                    <div className="flex items-start gap-3 pr-10 md:pr-12">
                        <span
                            className="flex-shrink-0 mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-white/15 backdrop-blur-sm"
                            aria-hidden="true"
                        >
                            <i className="fa fa-shield text-xs text-[#f87171]"></i>
                        </span>
                        <div className="text-sm md:text-md leading-relaxed">
                            <span className="inline-flex items-center gap-1.5 rounded-full bg-[#f87171]/20 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-[#fecaca] mr-2">
                                CONSUMER ALERT:
                            </span>
                            <span className="text-white/90">
                                ClearPath Lending has been made aware of fraudulent calls from an entity identifying
                                itself as &ldquo;ClearPath Lending Services.&rdquo;, &ldquo;ClearPath&rdquo; or
                                &ldquo;sister affiliates of our company&rdquo;. We are not affiliated with this
                                organization and do <strong>not</strong> offer personal loans, debt consolidation, or
                                debt settlement services.
                            </span>

                            <br />

                            <span className="text-white/90">
                                ClearPath Lending <strong>does not make unsolicited outbound calls</strong> or use
                                robocallers, auto-dialers, or AI-generated voices. We only contact individuals who have
                                directly reached out to us regarding home mortgage inquiries.
                            </span>
                        </div>
                    </div>
                </div>
                <button
                    type="button"
                    onClick={handleDismiss}
                    className="absolute top-2 right-2 flex h-11 w-11 items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-darkBlue cursor-pointer"
                    aria-label="Dismiss fraud alert"
                >
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        aria-hidden="true"
                    >
                        <path d="M3 3l8 8M11 3l-8 8" />
                    </svg>
                </button>
            </div>
            {/* Spacer to push page content below the fixed banner */}
            <div style={{ height: "var(--banner-height, 0px)" }} aria-hidden="true" />
        </>
    );
}

export default FraudBanner;
